.content {
  z-index: var(--z-popover);
  min-width: 220px; max-width: 320px; padding: var(--space-1-5);
  border-radius: var(--radius-md); background: var(--glass-raised); -webkit-backdrop-filter: var(--glass-blur); backdrop-filter: var(--glass-blur);
  border: 1px solid var(--glass-border); box-shadow: var(--shadow-3), var(--glass-edge);
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
  animation: in var(--duration-fast) var(--ease-out);
}
.content[data-state="closed"] { animation: out 100ms ease-out forwards; }
.item {
  display: flex; align-items: center; gap: var(--space-3);
  min-height: 36px; padding: 0 var(--space-3); border-radius: var(--radius-sm);
  color: var(--color-text); font-size: var(--text-md); cursor: default; user-select: none; outline: none;
}
.item[data-highlighted] { background: var(--glass-hover); }
.item[data-disabled] { color: var(--color-text-muted); }
.danger { color: var(--color-danger); }
.icon { display: grid; place-items: center; width: 18px; color: var(--color-text-secondary); }
.icon svg { width: 18px; height: 18px; }
.text { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.shortcut { display: inline-flex; gap: 2px; }
.key {
  display: inline-grid; place-items: center; min-width: 20px; height: 20px; padding: 0 4px;
  border: 1px solid var(--color-border); border-radius: 6px; background: var(--glass-hover);
  color: var(--color-text-muted); font: var(--weight-medium) var(--text-2xs) / 1 var(--font-ui);
}
.detail { color: var(--color-text-muted); font-size: var(--text-xs); font-variant-numeric: tabular-nums; white-space: nowrap; }
.chevron { display: grid; place-items: center; color: var(--color-text-muted); }
.chevron svg { width: 16px; height: 16px; }
.item[data-state="open"] { background: var(--glass-hover); }
.indicator { display: grid; place-items: center; color: var(--color-primary); }
.indicator svg { width: 16px; height: 16px; }
.label { padding: var(--space-2) var(--space-2-5, 10px) var(--space-1); color: var(--color-text-muted); font-size: var(--text-xs); font-weight: var(--weight-medium); }
.separator { height: 1px; margin: var(--space-1) calc(var(--space-1) * -1); background: var(--color-border); }
.box { display: grid; place-items: center; flex: none; width: 16px; height: 16px; border: 1.5px solid var(--color-border-strong); border-radius: 4px; }
.checkItem[data-state="checked"] .box, .checkItem[data-state="indeterminate"] .box { border-color: var(--color-primary); background: var(--color-primary); color: var(--color-text-on-primary); }
.boxMark { display: grid; place-items: center; }
.boxMark svg { width: 12px; height: 12px; stroke-width: 3; }
.dash { width: 8px; height: 2px; border-radius: 1px; background: currentColor; }
@keyframes in { from { opacity: 0; transform: scale(0.97); } }
@keyframes out { to { opacity: 0; transform: scale(0.98); } }
